import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks the restoration of an asset',
  name: 'restore_asset',
  params: [
    {
      description: 'The ID of the restored asset',
      name: 'asset_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The name of the restored asset',
      name: 'asset_name',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
